import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import { Caso } from '@/types/casos';
import { CasoCard } from './CasoCard';

interface DraggableCasoCardProps {
  caso: Caso;
}

export function DraggableCasoCard({ caso }: DraggableCasoCardProps) {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: `caso-${caso.id}`,
    data: { type: 'caso', caso },
  });

  const style = {
    transform: CSS.Translate.toString(transform),
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div ref={setNodeRef} style={style} {...listeners} {...attributes}>
      <CasoCard caso={caso} />
    </div>
  );
}
